(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningPathSelect", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/assignments/path/steps/learningPathSelectView.html",
            controller: ["learningPathResource", "$sessionStorage", "$timeout", "$scope", "$translate", "DTOptionsBuilder", "DTColumnDefBuilder", "_", LearningPathSelectCtrl],
            controllerAs: "vm"
        };
        function LearningPathSelectCtrl(learningPathResource, $sessionStorage, $timeout, $scope, $translate, DTOptionsBuilder, DTColumnDefBuilder, _) {
            var vm = this;
            //might need to do something like https://stackoverflow.com/questions/16845605/is-it-possible-to-update-parent-scope-from-angular-directive-with-scope-true
            //when switching to angular 1.5, 1.6
            vm.loaded = false;
            $scope.$parent.vm.stepIsValid = false;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.learningPaths = [];
            //Check to see if its first load or load from step 2
            if ($scope.$parent.vm.learningPaths.length !== 0) {
                vm.learningPaths = $scope.$parent.vm.learningPaths;
                vm.checkedAll = $scope.$parent.vm.isCheckedAllPath;
                vm.loaded = true;
            }
            else {
                learningPathResource.getPublishedPaths(function (data) {
                    vm.learningPaths = data;
                    vm.disableCheckAll = false;
                    $timeout(function () {
                        vm.loaded = true;
                    });
                });
            }
            //Session Storage for Omni box search
            if ($scope.$parent.vm.isGroupAssign) {
                if ($sessionStorage.assignLearningPathsToGroupsFilters) {
                    vm.dtSearch = $sessionStorage.assignLearningPathsToGroupsFilters.search;
                }
                else {
                    vm.dtSearch = "";
                }
            }
            else {
                if ($sessionStorage.assignLearningPathsToLearnersFilters) {
                    vm.dtSearch = $sessionStorage.assignLearningPathsToLearnersFilters.search;
                }
                else {
                    vm.dtSearch = "";
                }
            }
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("order", [2, "asc"])
                .withPaginationType("full_numbers")
                .withOption("fnDrawCallback", function () {
                vm.isValid();
                // if step1 loaded already means previous button press on step 2
                // This will prevent the initial previous button load from clearing selection
                if (!$scope.$parent.vm.loadedStep1) {
                    $timeout(function () {
                        vm.checkedAll = false;
                        $scope.$parent.vm.stepIsValid = false;
                        vm.clearSelection();
                        $scope.$apply();
                    });
                }
            })
                .withBootstrap();
            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(1).notSortable(),
                DTColumnDefBuilder.newColumnDef(0).withOption("searchable", false)
            ];
            //Function to determine if the form is valid
            vm.isValid = function () {
                var list = _.where(vm.learningPaths, { checked: true });
                if (list.length !== 0) {
                    $scope.$parent.vm.stepIsValid = true;
                    $scope.$parent.vm.selectionError = "";
                    $scope.$parent.vm.learningPaths = vm.learningPaths;
                }
                else {
                    $scope.$parent.vm.stepIsValid = false;
                    $scope.$parent.vm.selectionError = "assignments.assignPathToGroup.error.selectPath";
                }
            };
            //Function for when table is redrawn to clear all selections
            vm.clearSelection = function () {
                vm.checkedItems = {};
                vm.checkedItems = _.where(vm.learningPaths, { checked: true });
                for (var i = 0; i < vm.checkedItems.length; ++i) {
                    vm.checkedItems[i].checked = false;
                }
                $scope.$parent.vm.stepIsValid = false;
                $scope.$parent.vm.selectionError = "assignments.assignPathToGroup.error.selectPath";
            };
            //Function for when a check all box is clicked
            vm.selectAllClicked = function () {
                vm.selectItems = []; //cbox.items contains all checked checkboxes
                var oTable = vm.dtInstance.DataTable;
                var anNodes = $("#learningPaths tbody tr");
                for (var i = 0; i < anNodes.length; ++i) {
                    var rowData = oTable.row(anNodes[i]).data();
                    vm.selectItems.push(_.find(vm.learningPaths, { id: parseInt(rowData[0]) }));
                    vm.selectItems[i].checked = vm.checkedAll;
                }
                if (vm.checkedAll) {
                    $scope.$parent.vm.stepIsValid = true;
                    $scope.$parent.vm.selectionError = "";
                    $scope.$parent.vm.learningPaths = vm.learningPaths;
                }
                else {
                    $scope.$parent.vm.stepIsValid = false;
                    $scope.$parent.vm.selectionError = "assignments.assignPathToGroup.error.selectPath";
                }
                $scope.$parent.vm.isCheckedAllPath = vm.checkedAll;
            };
            vm.rowClicked = function (path) {
                path.checked = !path.checked;
                vm.isValid();
            };
            //Function for when a single row check box is clicked
            vm.itemChecked = function () {
                vm.items = []; //cbox.items contains all checked checkboxes
                var oTable = vm.dtInstance.DataTable;
                var anNodes = $("#learningPaths tbody tr");
                vm.isValid();
                for (var i = 0; i < anNodes.length; ++i) {
                    var rowData = oTable.row(anNodes[i]).data();
                    vm.items.push(_.find(vm.learningPaths, { id: parseInt(rowData[0]) }));
                }
                vm.checkedAll = _.every(vm.items, { checked: true });
                $scope.$parent.vm.isCheckedAllPath = vm.checkedAll;
            };
            vm.dtInstanceCallback = function (instance) {
                $scope.$parent.vm.dtPathInstance = instance;
                //if (!$scope.$parent.vm.loadedStep1) {
                //	$scope.$parent.vm.dtPathInstance.DataTable.state.clear();
                //	vm.dtSearch = "";
                //}
                vm.dtInstance = instance;
                vm.search();
            };
            vm.search = function () {
                if ($scope.$parent.vm.isGroupAssign) {
                    $sessionStorage.assignLearningPathsToGroupsFilters = { search: vm.dtSearch };
                }
                else {
                    $sessionStorage.assignLearningPathsToLearnersFilters = { search: vm.dtSearch };
                }
                vm.dtInstance.DataTable.search(vm.dtSearch).draw();
                $timeout(function () {
                    vm.disableCheckAll = angular.element(".dataTables_empty").length > 0;
                });
            };
        }
    });
}());
